module.exports = __webpack_public_path__ + "img/case01.1ebbf187.png";